export const faqs = [
  {
    question: 'What is Walmart Realm, and why should I care?',
    answer:
      "Walmart Realm is the world's only creator-curated immersive shopping marketplace, a vibrant and inspiring wonderland of virtual stores. For creators, Realm gives you an amazing opportunity to build your following, an immersive new way to interact with your followers, and a great way to build your brand. <br/> <br/> Realm lets you build the store of your dreams that reflects you and your brand.",
  },
  {
    question: 'Where do I download the Realm Store Builder app?',
    answer: 'Get the latest build of the Realm Store Builder app from the app store',
  },
  {
    question: 'Can I install the Realm Store Builder app on Android?',
    answer:
      'Not at this time; currently, Walmart Realm is only available on iOS through the App Store. An Android version may be added in the future.',
  },
  {
    question: 'What are the technological requirements to run the Realm Store Builder app?',
    answer: 'Walmart Realm Store Builder app only works on iOS devices at this time.',
  },
  {
    question: 'Am I required to post a profile photo?',
    answer:
      'Yes, and we suggest using the same photo you use on your other social media channels so that your followers can immediately identify you.',
  },
  {
    question: 'Should I use my real name or my social media name?',
    answer:
      'Use your social media name so that your followers can find you, and also so Walmart Realm helps you grow awareness about your online brand.',
  },
  {
    question: 'Can I customize my theme?',
    answer:
      'Yes! You can pick from a theme in the library, and then customize the Layout Size of the theme to serve your curation needs.',
  },
  {
    question: 'Can I customize the layout?',
    answer:
      'After picking a theme, you can pick from the preset layout size options. <br /> <br /> However, at this time we do not allow for layouts to be further customized or rearranged.',
  },
  {
    question: 'How do I change the theme or layout if I don’t like the one I picked?',
    answer:
      'You will not be able to change the theme or layout after you have selected them and begun editing the store’s contents. Instead, if you wish to use a different theme or layout, create a brand new store and go through the steps of selecting theme and layout.',
  },
  {
    question: 'Will more themes and layouts be available at some point?',
    answer:
      'Yes! We will continue to add new themes and layouts to the store builder in the future, so check back regularly for updates.',
  },
  {
    question: 'Can I create more than one store?',
    answer: 'Yes you can! Simply go to the home screen of the app and tap on the “New Store” button',
  },
  {
    question: 'Why do different products show up for each slot in my store?',
    answer:
      'Every slot in a store varies in the size and format of items it can carry—for example, a large furniture item won’t fit onto a small display meant for table-top products. When you select a slot, only the products that fit within the selected slot will be shown in the product catalog.',
  },
  {
    question: 'What is a “bundle” and why should I use them?',
    answer:
      'A bundle is a collection of products that have aesthetic and utility when purchased together, for example a chair that’s paired with a side table and lamp. Bundles will allow shoppers to add all the bundled items to their cart at once. <br /> <br/> We recommend using bundles when possible, so that you increase the likelihood of selling multiple items.',
  },
  {
    question: 'How often are new products added to the catalog?',
    answer: 'We add new products to the catalog every 4–6 weeks',
  },
  {
    question: 'Can I change the products in my store after publishing?',
    answer: 'Yes, but you will need to re-submit and re-publish your store after making any changes',
  },
  {
    question: 'How many videos can I add to my store?',
    answer:
      'At this time we only provide the option of adding one video. <br /> <br />  In the future, we may provide more opportunities for adding video content to your store.',
  },
  {
    question: 'How long should my video be?',
    answer:
      'We recommend keeping your video between 30 seconds and 1 minute. That will give you enough time to briefly introduce yourself and the great merchandise you’ve curated for your store.',
  },
  {
    question: 'What should my video be about?',
    answer:
      'Use the video to introduce yourself and your brand to people who may be encountering you for the very first time. Welcome them to your store, and give them a brief overview of your product niche and thematic focus, and tell them about anything especially interesting or worthwhile to explore while they’re shopping.',
  },
  {
    question: 'What should I write for my store description?',
    answer:
      'Your store description should clearly describe your lifestyle niche and product categories you curated for your visitors. Ideally, try to communicate all of this information in one sentence.',
  },
  {
    question: 'How many tags should I use for my store?',
    answer: 'We suggest using a minimum of 3 tags.',
  },
  {
    question: 'Can I upload my own music to my store?',
    answer: 'Not at this time.',
  },
  {
    question: 'How long does approval usually take?',
    answer: 'You should hear back within 1-2 business days submitting your entry.',
  },
  {
    question: 'Why did my store get rejected?',
    answer:
      'Your store may be rejected for a number of reasons, including: <li>your store details did not match your curated experience</li> <li>your store did not clearly present a niche or story about the products you curated</li><li>your video did not meet Walmart Realm standards. Remember that your video should be between 30 seconds to 1 minute, introduce people to you and the product selection you’ve curated, and generally provide a good first impression</li> <p>If rejected, your Walmart point of contact will reach out to you to discuss next steps for helping you reach approval.</p>',
  },
  {
    question: 'Can I change my store after approval?',
    answer:
      'You can freely edit store details after approval at any time. However, any changes you make to the product selection or video content will require you re-submit the store for review and approval again before you can publish the new changes.',
  },
  {
    question: 'Profile picture',
    answer:
      'Use a profile picture and name that your audience can easily recognize. Ideally the same username and photo you use on social media',
  },
  {
    question: 'Curate products that build your brand',
    answer:
      'Rather than randomly select products, think carefully about the right product story that fits your personal brand, then select products that add value to your brand. For example, if you are known for reviewing natural beauty products, your store should focus on natural beauty and not something totally unexpected. <img width="400px" height="400px" src="https://walmart.emperia-staging.com/realm-assets/second_instruction.png" alt="Notification Permissions" />',
  },
  {
    question: 'Test your store thoroughly before publishing',
    answer:
      'Always preview your store and click on everything in it to make sure you’re happy with the experience before you submit for review. Verify that products are all showing up, your arrangement of items feels good, and if your video makes the right first impression for people who are unfamiliar with you.',
  },
  {
    question: 'Make your store memorable',
    answer:
      'Your store name and description should stand apart and reflect your unique personality, while also clearly communicating your niche and product focus. The name and description will directly impact how easily people can find your store..',
  },
  {
    question: 'Don’t duplicate products',
    answer: 'Avoid placing the same item into multiple slots within your store.',
  },
  {
    question: 'Don’t leave empty space',
    answer: 'Make sure every slot of your store is filled with a product you find relevant and valuable.',
  },
  {
    question: 'Avoid controversial or offensive content',
    answer:
      'Your store will be flagged and rejected if you use profanity, offensive content, or controversial content in your video or store details.',
  },
  {
    question: "I'm not getting notifications from the app",
    answer:
      'Make sure you enable all permissions that the Walmart Realm Store Builder app requests, so that you can get timely notifications when your store is ready for your input or action. <img width="200px" height="200px" src="https://walmart.emperia-staging.com/realm-assets/first_instruction.png" alt="Notification Permissions" />',
  },
  {
    question: 'I don’t see my photos or videos when trying to upload content or profile pictures',
    answer: 'Make sure you allow the app to access to your photo album.',
  },
  {
    question: 'Why do I need to allow microphone access?',
    answer:
      'Microphone access is purely needed as a technical step to ensure a reliable data connection. We do not record or collect any of your microphone data.',
  },
  {
    question: 'Is the app supposed to take a long time to load?',
    answer:
      'When first opening the app, please allow 1–3 minutes for the app to connect to the server and load store building resources. Keep an eye on the cloud icon. When you see the green checkmark on the icon, you can start building.',
  },
  {
    question: 'Why is the screen black when I load the store editor?',
    answer:
      'When you are first loading a store theme and layout, the app normally starts on a black screen that lasts up to several seconds.',
  },
  {
    question: 'Is my editor running slowly?',
    answer:
      'Every product you add will require a few seconds to render in 3D, up to several seconds per item you load. Our remote servers are rendering 3D updates in real time so know that the loading time is normal.',
  },
  {
    question: 'How long does a preview take to generate?',
    answer:
      'Usually 15–20 minutes. Make sure you allow app notifications so that you can do other stuff while the preview is rendered in the background. When the preview is done rendering, the app will notify you to come back and look at the store you’ve designed. <br /> <br /> <b>Important</b>: when generating a preview, make sure to leave your app open in the background. DO NOT CLOSE THE APP because that will cause you to lose your work.',
  },
];
